var gridItemMarkup = `
  <div class="row">
    {{#products}}
      <div class="col-6 col-md-4 col-lg-3 wishlist-item">
        <a class="wishlist-link" href="{{du}}">
          <div class="wishlist-img-wrapper">
            <img alt="{{dt}}" src="{{iu}}">
          </div>
          <h3 class="wishlist-title">{{dt}}</h3>
          <span class="wishlist-price">&#36;{{pr}}</span>
          <button class="wishlist-remove-btn" id="delete-btn" data-variant-id="{{epi}}" data-product-id="{{empi}}">
            <span class="sr-only">Delete {{dt}} from wishlist</span>
            <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" width="18.707" height="18.707" viewBox="0 0 18.707 18.707" aria-hidden="true">
              <g fill="none" stroke="#bac0c9">
                <path data-name="Line 2" d="M.354.354l18 18"/>
                <path data-name="Line 4" d="M18.354.354l-18 18"/>
              </g>
            </svg>
          </button>
        </a>
        <button class="wishlist-cta-btn btn btn--primary" id="add-to-cart-btn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}">
          {{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
        </button>
      </div>
    {{/products}}
  </div>`;

var listItemMarkup = `
  <div class="row">
    {{#products}}
      <div class="col-12 wishlist-item">
        <a class="wishlist-link" href="{{du}}">
          <div class="wishlist-img-wrapper">
            <img alt="{{dt}}" src="{{iu}}">
          </div>
          <div class="wishlist-content">
            <h3 class="wishlist-title">{{dt}}</h3>
            <span class="wishlist-price">&#36;{{pr}}</span>
          </div>
        </a>
        <div class="wishlist-btns">
          <button class="wishlist-cta-btn btn btn--primary" id="add-to-cart-btn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}">
            {{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
          </button>
          <button class="wishlist-remove-btn text-link" id="delete-btn" data-variant-id="{{epi}}" data-product-id="{{empi}}">delete<span class="sr-only"> {{dt}} from wishlist</span></button>
        </div>
      </div>
    {{/products}}
  </div>`;

var currentLayout = "grid";
var formattedProducts = [];

function initWishlist(swat) {
  swat.fetch(function (products) {
    formattedProducts = products.map(function (product) {
      // keep the item 'added to cart' status even after refreshing page
      product.isInCart =
        swat.platform.isInDeviceCart(product.epi) ||
        product.et == swat.EventTypes.addToCart;

      return product;
    });

    renderWishlist(formattedProducts);
  });
}

function renderWishlist(products) {
  var itemMarkup = currentLayout === "grid" ? gridItemMarkup : listItemMarkup;
  var itemsMarkup = SwymUtils.renderTemplateString(itemMarkup, {
    products: products,
  });
  var wishlistContainer = document.querySelector("#wishlist-container");

  wishlistContainer.innerHTML = itemsMarkup;

  attachClickListeners();
}

function attachClickListeners() {
  var addToCartBtns = document.querySelectorAll("#add-to-cart-btn");
  var deleteBtns = document.querySelectorAll("#delete-btn");
  var switchLayoutBtns = document.querySelectorAll(".wishlist-layout-btn");
  var searchInput = document.querySelector("#search-input");

  addToCartBtns.forEach(function (btn) {
    btn.addEventListener("click", onAddToCart, false);
  });

  deleteBtns.forEach(function (btn) {
    btn.addEventListener("click", onRemoveFromList, false);
  });

  switchLayoutBtns.forEach(function (btn) {
    btn.addEventListener("click", onSwitchLayout, false);
  });

  searchInput.addEventListener("keyup", onSearch);
}

function onAddToCart(e) {
  e.preventDefault();

  var productId = e.currentTarget.dataset.productId;
  var variantId = e.currentTarget.dataset.variantId;
  var productUrl = e.currentTarget.dataset.productUrl;

  e.target.innerHTML = "Adding..";

  window._swat.replayAddToCart(
    {
      empi: productId,
      du: productUrl,
    },
    variantId,
    function (response) {
      e.target.innerHTML = "Added to Cart";
      e.target.dataset.stateCart = "swym-added";
      console.log(response);
    },
    function (e) {
      console.log(e);
    }
  );
}

function onRemoveFromList(e) {
  e.preventDefault();

  var variantId = e.currentTarget.dataset.variantId;
  var productId = e.currentTarget.dataset.productId;

  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (
        variantId &&
        productId &&
        product.epi == variantId &&
        product.empi == productId
      ) {
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }

          window.SwymCallbacks.push(initWishlist);
        });
      }
    });
  });
}

function onSwitchLayout(e) {
  var layout = e.currentTarget.dataset.layout;
  var wishlistContainer = document.querySelector("#wishlist-container");
  var hasPrevLayoutStyle = wishlistContainer.className.match(
    /\bwishlist-container--\b/
  );
  var switchLayoutBtns = document.querySelectorAll(".wishlist-layout-btn");
  var searchInput = document.querySelector("#search-input");

  searchInput.value = "";

  switchLayoutBtns.forEach(function (btn) {
    btn.classList.remove("is-active");
  });
  e.currentTarget.classList.add("is-active");

  if (hasPrevLayoutStyle) {
    wishlistContainer.className = "wishlist-container";
  }
  wishlistContainer.classList.add(`wishlist-container--${layout}`);

  currentLayout = layout;

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(initWishlist);
}

function onSearch(e) {
  var searchString = e.target.value.toLowerCase();
  var filterdProducts = formattedProducts.filter(function (product) {
    return product.dt.toLowerCase().includes(searchString);
  });

  renderWishlist(filterdProducts);
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(initWishlist);
